module.exports = __webpack_public_path__ + "static/media/view4.1a014c91.jpg";